import * as React from "react";
// import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import swal from "sweetalert";
import { makePostRequest } from "../../../utils/utils";
import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { WindowOutlined } from "@mui/icons-material";

function AddCommitteeMemberModal() {
  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };
  // const navigate = useNavigate();

  const [residentlist, setresidentlist] = React.useState([]);
  const [q] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(false);
  const [selectedResident,setSelectedResident]=React.useState();
  const [designation,setDesignation]=React.useState();

  async function residentlisting() {

    let bodyFormData = {
      searchq: q,
      pageNo: "",
      count: "",
      isTenent: false,
    };
    setShowLoader(true);
  await makePostRequest("resident/residentlisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data.data;
          setresidentlist(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        let errMsg = err.response.data.message;
        swal(errMsg, "", "warning");
        setShowLoader(false);
      });
  }

  async function handleChangeResident(e){
    // alert(e.target.value);
    setSelectedResident(e.target.value);
  }

  async function handleChangeDesignation(e)
  {
    // alert(e.target.value);
    setDesignation(e.target.value);
  }

  async function addCommiteeMember()
  { 
    if(selectedResident&&designation)
    {

       let inputdata = {
        resident_id: selectedResident,
        user_designation:designation
      }

      await makePostRequest("resident/update", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
            swal("Success", "Commitee Member Added Successfully", "success", {
              timer: 1000,
              buttons: false,
            });
           window.location.reload();
            }
          })
          .catch((err) => {
            setShowLoader(false);
            swal(" " + err.response.data.message, "", "warning", {
              timer: 2000,
              buttons: false,
            });
          });
    }
    else
    {
      swal("Warning ", "Please Select Resident and Designation", "warning", {
        timer: 2000,
        buttons: false,
      });
    }
   
  }

  useEffect(() => {

    if(localStorage.getItem('isCommiteeMemEdit'))
    {
     setSelectedResident(localStorage.getItem('selectedCommiteeMem'));
     setDesignation(localStorage.getItem('selectedDesignation'));
    }
    else
      residentlisting();
  }, [q]);

  return (
    <>
      <div id="successfullAdd">
        <Grid container spacing={3} className="addCommitee1">
          {/* <Grid item xs={12} md={12}>
            <div className="modalInput">
              <SearchIcon />
              <input className="modalInputSt" placeholder="Search here" onChangeCapture={(e) => setQ(e.target.value)}/>
            </div>
          </Grid> */}
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">Select Resident</label>
            <select className="modalInputStSelect" value={selectedResident}  onChange={handleChangeResident}>
            <option>Select Resident</option>
              {residentlist.map((option1,index)=>(
              <option  key={option1.resident_id} 
              value={
                option1.resident_id
              }
              >{option1.user_obj.first_name} {option1.user_obj.last_name}</option>
              ))}
            </select>
          </Grid>
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">Select Designation</label>
            <select className="modalInputStSelect"  value={designation}
                                                    onChange={
                                                      handleChangeDesignation
                                                    }>
              <option>Select Designation</option>
              <option value="General Manager">General Manager</option>
              <option value="Chairman">Chairman</option>
              <option value="Treasurer">Treasurer</option>
              <option value="Secretary">Secretary</option>
              <option value="Committee Member">Committee Member</option>
            </select>
          </Grid>
          {/* <Grid item xs={12} md={12}>
            <p className="portalHeading">Portal Access</p>
            <div className="portlAccMain">
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Portal One"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Society Admin"
                />
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Portal Two"
                />
                <FormControlLabel control={<Checkbox />} label="Portal Three" />
              </FormGroup>
            </div>
          </Grid> */}
          <Grid item xs={12} md={12}>
            <div className="modalMainBtMain">
              <Button className="modalMainBt" onClick={addCommiteeMember}>
                Add Member
              </Button>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>
                Committee member added <br />
                successfully in database
              </p>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
  
    </>
  );
}
export default AddCommitteeMemberModal;
